import { Link } from "react-router-dom";
import { ExternalLink, Pin } from "lucide-react";

/**
 * PageGrid — renders the "Explore pages" section on /u/:slug legacy
 * fallback. Each card links to /u/:creator/:page and fires a click event.
 */
export function PageGrid({ pages, creatorSlug, trackClick }) {
  if (!pages || pages.length === 0) return null;
  return (
    <section data-testid="creator-directory-pages-section">
      <p className="overline mb-3">Explore pages</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {pages.map((p, i) => (
          <Link
            key={p.page_id}
            to={`/u/${creatorSlug}/${p.slug}`}
            onClick={() => trackClick("page", p.page_id, `/u/${creatorSlug}/${p.slug}`)}
            className="block rounded-2xl bg-white p-4 transition-transform relative hover:-translate-y-[1px]"
            style={{ border: "1px solid var(--ux-border)", boxShadow: "var(--ux-shadow-1)" }}
            data-testid={`creator-directory-page-${i}`}
          >
            {p.pinned && (
              <span
                className="absolute -top-2 -right-2 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase inline-flex items-center gap-1"
                style={{
                  background: "color-mix(in srgb, var(--ux-sun) 60%, white)",
                  border: "1px solid var(--ux-border)",
                  color: "var(--ux-ink)",
                }}
                data-testid={`creator-directory-page-pinned-${i}`}
              >
                <Pin className="w-2.5 h-2.5" /> Pinned
              </span>
            )}
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 flex-1">
                <p className="font-bold text-base truncate">{p.title}</p>
                {p.description && (
                  <p className="text-xs mt-0.5 line-clamp-2" style={{ color: "var(--ux-ink-2)" }}>
                    {p.description}
                  </p>
                )}
                <code className="text-[10px] font-mono" style={{ color: "var(--ux-ink-3)" }}>
                  /{p.slug}
                </code>
              </div>
              <ExternalLink className="w-4 h-4 flex-shrink-0" style={{ color: "var(--ux-ink-3)" }} />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
